// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NotFound_wrapper__24SvH","image":"NotFound_image__1BUZx","alert":"NotFound_alert__2mjvJ"};